<template>
  <div :class="classObj" class="app-wrapper">
    <!-- <div class="header">Header</div> -->
    <div
      v-if="device === 'mobile' && sidebar.opened"
      class="drawer-bg"
      @click="handleClickOutside"
    />
    <sidebar class="sidebar-container" />
    <div :class="{ hasTagsView: needTagsView }" class="main-container">
      <div class="fixed-header">
        <!-- { 'fixed-header': fixedHeader } -->
        <!-- <BirthdayMarQuee /> -->
        <navbar />
        <!-- <tags-view v-if="needTagsView" /> -->
      </div>
      <extra-sidebar />
      <app-main />
      <!-- noti list -->
      <portal-target name="tax"></portal-target>
      <!-- <right-panel v-if="showSettings" width="33">
        <template>
          <h1>Hello world</h1>
        </template>
      </right-panel> -->
    </div>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
// import BirthdayMarQuee from '@/components/BirthdayMarquee'
import { AppMain, Navbar, Settings, Sidebar, ExtraSidebar } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import { getMenuListApi } from '@/api/auth_service/authManage'
import { setSidebarMenuList } from '@/utils/auth'
import { getToken } from '@/utils/auth'

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    // eslint-disable-next-line vue/no-unused-components
    RightPanel,
    // eslint-disable-next-line vue/no-unused-components
    Settings,
    Sidebar,
    ExtraSidebar
    // TagsView
    // BirthdayMarQuee
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  beforeMount() {
    const token = getToken()
    if (token) {
      this.fnGetRouteList()
    }
  },
  mounted() {},
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    async fnGetRouteList() {
      await getMenuListApi().then(res => {
        setSidebarMenuList(res.data)
      })
      // .catch(error => {
      //   console.log(error)
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  min-width: $tablet-w !important;
  position: relative;
  height: 100%;
  width: 100%;
  background: $appBG;
  // background: transparent; // $appBG;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 72px);
}

.mobile .fixed-header {
  width: calc(100% - 72px);
}
.header {
  width: 100%;
  height: 70px;
  background: #304156;
  text-align: center;
  line-height: 70px;
  color: white;
  font-weight: 600;
}
</style>
